import { ValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const hasOneUppercaseValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const valid = control.value.match(/[A-Z]/g);
    return (valid ? null : {'hasOneUppercase': true});
};
